import { TableBodyCell } from '../../../../../MyTickets.styled';
import { CategoryCellProps } from './CategoryCell.types';
import { ticketCategoryLookUp } from 'src/components/Tickets/MyTickets.constants';

export const CategoryCell = ({ category }: CategoryCellProps) => {
  return <TableBodyCell>{ticketCategoryLookUp[category].label}</TableBodyCell>;
};
